import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lm-saved-search-manage',
  template: `
    <lm-list #lmlist
        *ngIf="(listSpec)"
        [listUrlInfo]="listUrlInfo"
        [listSpec]="listSpec"
        [ngStyle]="{'width': '100%'}"
    >
    </lm-list>
  `
})
export class LMSavedSearchManageComponent implements OnInit {

  @Input() listSpec: LMListSpec;
  @Input() listUrlInfo: LMListUrlInfo;
  constructor() { }

  ngOnInit(): void {
  }
}
